<template>
  <div class="container-fluid d-flex flex-column flex-grow-1">
    <div class="row mt-4">
      <div class="col-2">
        <DailySubscribedCountComponent />
      </div>
      <div class="col-2">
        <WeeklySubscribedCountComponent />
      </div>
      <div class="col-2">
        <MonthlySubscribedCountComponent />
      </div>
      <div class="col-3">
        <SmsCompanyCountComponent />
      </div>
      <div class="col-3">
        <UnsubscribedCountComponent />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <SubscribedCountLineChartComponent />
      </div>
    </div>
  </div>
</template>

<script>
import SmsCompanyCountComponent from '@/components/dashboard/SmsCompanyCountComponent'
import UnsubscribedCountComponent from '@/components/dashboard/UnsubscribedCountComponent'
import DailySubscribedCountComponent from '@/components/dashboard/DailySubscribedCountComponent'
import WeeklySubscribedCountComponent from '@/components/dashboard/WeeklySubscribedCountComponent'
import MonthlySubscribedCountComponent from '@/components/dashboard/MonthlySubscribedCountComponent'
import SubscribedCountLineChartComponent from '@/components/dashboard/SubscribedCountLineChartComponent'
export default {
  name: 'SmsDashboardPage',
  components: {
    SmsCompanyCountComponent,
    UnsubscribedCountComponent,
    DailySubscribedCountComponent,
    WeeklySubscribedCountComponent,
    MonthlySubscribedCountComponent,
    SubscribedCountLineChartComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dashboard/SmsDashboardPage.vue